export default __webpack_public_path__ + "static/media/axios.bd6acdab.svg";